var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded px-1",class:_vm.getClassName(_vm.color)},[_c('span',{staticClass:"m-0 font-size-14 text-center font-weight-500"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }